import { FC } from 'react';

// ========================= 组件 =========================
import LoadMoreButton from '../LoadMoreButton';

// ========================= 数据交互 =========================

// ========================= 全局数据 =========================

// ========================= 常量 =========================

// ========================= 工具 =========================
import { useTranslation } from 'next-i18next';

// ========================= 样式 =========================
import styles from './index.module.css';
import useScrollHandler from '@/hooks/useScrollHandler';

// ========================= 变量 =========================

// ========================= 类型 =========================

interface Item {
    id: number;
    [key: string]: any;
}

interface ConferenceItemProps {
    items: Item[];
    /**
     * @description: 是否加载中
     * @return {*}
     */
    loading?: boolean;
    /**
     * @description: 总数
     * @return {*}
     */
    total?: number;
    /**
     * @description: 滚动到底部加载更多
     * @return {*}
     */
    onScrollButton?: () => void;
    /**
     * @description: 是否显示加载中
     * @return {*}
     */
    showLoading?: boolean;
    /**
     * @description: 是否显示更多按钮
     * @return {*}
     */
    showMore?: boolean;
    /**
     * @description: 渲染每个item
     * @return {*}
     */
    itemRender?: (item: Item, index: number) => React.ReactNode;
    /**
     * @description: 字段名
     * @return {*}
     */
    fieldNames?: {
        id: string;
        title: string;
        image: string;
        [key: string]: string;
    }
    /**
     * @description: 是否禁用滚动监听
     * @return {*}
     */
    scrollDisable?: boolean;
    /**
     * @description: 查看更多 跳转链接
     * @return {*}
     */
    linkHref?: string | ((items: Item[]) => string);
}
/**
 * @description: 大会专区-通用列表item
 * @param {*} props
 * @return {*}
 */
const ConferenceItem: FC<ConferenceItemProps> = ({
    items = [],
    showMore = true,
    showLoading = false,
    loading,
    scrollDisable = false,
    fieldNames = {
        id: 'id',
        title: 'title',
        image: 'photoUrl',
    },
    total = 0,
    linkHref = '#',
    onScrollButton,
    itemRender,
}) => {

    const { t } = useTranslation('common');


    const { loadingRender, finishRender } = useScrollHandler({
        loading,
        total,
        length: Array.isArray(items) ? items.length : 0,
        onScrollButton,
        disable: scrollDisable,
        isTopButton: true,
    });

    return (
        <>
            <ul className={styles['container']}>
                {
                    items.map((item, index) => (
                        <li className={styles['item']} key={item[fieldNames.id]} >
                            {itemRender ? itemRender(item, index) : null}
                        </li>
                    ))
                }
            </ul>

            {showMore && Boolean(items.length) && <LoadMoreButton linkHref={typeof linkHref === 'string' ? linkHref : linkHref(items)} buttonText={t('moreText')} />}
            {
                showLoading && (
                    <>
                        {loadingRender}
                        {finishRender}
                    </>
                )
            }
        </>
    );
}
export default ConferenceItem;